import { PricingPageProps } from '../../types/components/pricing/PricingPage';

import PlanVariantsWrapper from './PlanVariantsWrapper';
import HowDoPlansWork from './HowDoPlansWork';
import TestimonialSection from './TestimonialSection';
import Cta from './Cta'
import Faq from './Faq';
import MoreQuestionsSection from './MoreQuestionsSection';

const PricingPage: React.FC<PricingPageProps> = ({
  pageContent,
  planVariants,
}) => {
  return (
    <div className="bg-[#15191B]" cy-test-id="pricing-page">
      <TestimonialSection
        pageContent={pageContent}
      />
      <HowDoPlansWork />
      <PlanVariantsWrapper
        planVariants={planVariants}
        pageContent={pageContent}
      />
      <Cta />
      <div className="h-9"/>
      <Faq
        pageContent={pageContent}
      />
      <MoreQuestionsSection
        pageContent={pageContent}
      />
    </div>
  );
}

export default PricingPage;
